import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { NgbDate } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-datepicker',
  templateUrl: './datepicker.component.html',
  styleUrls: ['./datepicker.component.css']
})
export class DatepickerComponent implements OnInit {

  @Input() disabled: boolean;
  @Input() model: any;
  @Input() placeholder: string;
  @Input() markDisabledFunction
  : (date: NgbDate) => boolean // type
  = (date: NgbDate) => { return false; }; // default implementation
  @Input() showOtherMonthDays: string = "visible";
  @Output() modelChange = new EventEmitter<any>();
  @ViewChild('datepickerInput', { static: false })
  datepickerInput: any;

  constructor() { }

  ngOnInit() {
  }

  modelChanged(val) {
    this.model = val;
    this.modelChange.emit(this.model);
  }
}
